module.exports = __webpack_public_path__ + "media/top-video.0633c3d9.mp4";